module.exports = __webpack_public_path__ + "static/img/blue.94ce08b.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/blue.gif
// module id = Mige
// module chunks = 1